var _path, _path2, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9H17.25",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12L12.75 12",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H14.25H8.25",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18C4.08579 18 3.75 18.3358 3.75 18.75L3.75 19.5C3.75 20.7426 4.75736 21.75 6 21.75L16.5 21.75L16.5 18.75C16.5 18.3358 16.1642 18 15.75 18L4.5 18Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15,
    r: 0.75,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3H20.25C20.25 2.71568 20.0892 2.45581 19.8348 2.32888C19.5804 2.20196 19.2761 2.2298 19.0489 2.4008L19.5 3ZM15.8027 5.7832L15.2974 6.33744L15.757 6.7564L16.2538 6.3824L15.8027 5.7832ZM12.75 3L13.2553 2.44577C12.9688 2.18456 12.5304 2.18477 12.2442 2.44625L12.75 3ZM9.70312 5.7832L9.25252 6.38275L9.74972 6.75644L10.209 6.33695L9.70312 5.7832ZM6 3L6.45061 2.40046C6.22341 2.2297 5.9192 2.20203 5.66493 2.32901C5.41065 2.45599 5.25 2.71578 5.25 3H6ZM16.5 22.5H17.25V21H16.5V22.5ZM20.25 19.5V3H18.75V19.5H20.25ZM19.0489 2.4008L15.3517 5.184L16.2538 6.3824L19.9511 3.5992L19.0489 2.4008ZM16.308 5.22897L13.2553 2.44577L12.2447 3.55423L15.2974 6.33744L16.308 5.22897ZM12.2442 2.44625L9.1973 5.22945L10.209 6.33695L13.2558 3.55375L12.2442 2.44625ZM10.1537 5.18366L6.45061 2.40046L5.54939 3.59954L9.25252 6.38275L10.1537 5.18366ZM5.25 3V18H6.75V3H5.25ZM17.25 22.5C18.9069 22.5 20.25 21.1569 20.25 19.5H18.75C18.75 20.3284 18.0784 21 17.25 21V22.5Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt24);
export default __webpack_public_path__ + "static/media/Receipt-24.a6b5504d.svg";
export { ForwardRef as ReactComponent };